import { queryKeysFactory } from "@/core/config";

import { GetTodosParams } from "@/tasks/types";

export const queryKeysTasks = {
  all: ["tasks"] as const,

  lists: () => [...queryKeysFactory.lists("tasks")] as const,
  list: (params: GetTodosParams) =>
    [...queryKeysFactory.lists("tasks"), params] as const,

  details: () => [...queryKeysFactory.details("tasks")] as const,
  detail: (id: number) => [...queryKeysFactory.details("tasks"), id] as const,
};
